/** Renders exact server-resolved answer/exchange citations with native source navigation. */
import type { ShopifyResultQuote } from '@testfeed/shopify-contracts'
import { ServerOriginalExchange } from './ServerOriginalExchange'
import { ServerResultSource, ServerResultSourceLink } from './ServerResultSource'

export function ServerResultQuote({ answer }: { answer: ShopifyResultQuote }) {
  const exchange = answer.originalExchange
  if (!exchange) return <ResultQuoteContent answer={answer} />
  return (
    <ServerResultSource exchange={exchange}>
      <ResultQuoteContent answer={answer} />
    </ServerResultSource>
  )
}

function ResultQuoteContent({ answer }: { answer: ShopifyResultQuote }) {
  if (answer.citationUnit === 'exchange')
    return (
      <s-stack direction="block" gap="base">
        <s-text color="subdued">{answer.source}</s-text>
        <ServerOriginalExchange exchange={answer.originalExchange} />
      </s-stack>
    )
  return (
    <s-stack direction="block" gap="base">
      <s-text color="subdued">{answer.source}</s-text>
      <SourceQuestion text={answer.question} />
      <blockquote className="response-phrase-quote">
        “
        {answer.segments.map((segment, index) => (
          <QuoteSegment key={index} segment={segment} />
        ))}
        ”
      </blockquote>
      <ServerOriginalExchange exchange={answer.originalExchange} />
    </s-stack>
  )
}

type AnswerSegment = Extract<ShopifyResultQuote, { citationUnit: 'answer' }>['segments'][number]
function QuoteSegment({ segment }: { segment: AnswerSegment }) {
  if (segment.highlighted && segment.sourceTarget)
    return (
      <ServerResultSourceLink answerId={segment.sourceTarget.answerId} segments={segment.sourceTarget.segments}>
        <mark>{segment.text}</mark>
      </ServerResultSourceLink>
    )
  if (segment.highlighted) return <mark>{segment.text}</mark>
  return <>{segment.text}</>
}

function SourceQuestion({ text }: { text: string | null }) {
  if (!text) return null
  return <s-text type="strong">{text}</s-text>
}
